import { IKnmReasonChangeType } from 'APIPackage/CatalogsModule/interfaces/IKnmReasonChangeType';
import { apiDelete, apiGet, apiPost, apiPut } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { IKnmPlanRaw } from 'APIPackage/PlanListModule/interfaces/IKnmPlanRaw';
import { IKnmPlan } from 'PlanListPackage/MainModule/interfaces/IKnmPlan';

import { IKnm } from '../interfaces/IKnm';
import { IKnmDocument } from '../interfaces/IKnmDocument';
import { IKnmExclusionRequest } from '../interfaces/IKnmExclusionRequest';
import { IKnmPlanFind } from '../interfaces/IKnmPlanFind';
import { IKnmPunishmentNature } from '../interfaces/IKnmPunishmentNature';
import { IValidatedUnsignedKnmByPlan } from '../interfaces/IValidatedUnsignedKnmByPlan';
import { IPlanKnoChangeHistoryItem } from '../../../ChangeKnoInPlanPackage/components/IPlanKnoChangeHistoryItem';

export async function linkKnmToPlan(
  planId: IKnmPlanRaw['id'],
  knmId: IKnm['erpId'],
  reasonChangeTypeDTO?: IKnmReasonChangeType,
): Promise<void> {
  return apiPut(`${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/knm/${knmId}/plan/link`, {
    planId,
    reasonChangeTypeDTO,
  });
}

export async function fetchKnmIdsByPlanId(planId: IKnmPlan['id']): Promise<Array<IKnm['id']>> {
  return apiGet<Array<IKnm['id']>>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/knm/by-plan/${planId}`);
}

export async function fetchUnsignedKnmIdsByPlanId(planId: IKnmPlan['id']): Promise<Array<IKnm['id']>> {
  return apiGet<Array<IKnm['id']>>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/knm-plan/${planId}/knm/unsigned`);
}

export async function fetchKnmPlanFind(planId: number): Promise<IKnmPlanFind> {
  return apiGet<IKnmPlanFind>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/knm-plan/${planId}`);
}

export async function fetchValidateUnsignedKnmByPlanId(
  planId: number,
  fioSigner: string,
  fioSignerCN: string,
  organizationName: string,
): Promise<IValidatedUnsignedKnmByPlan> {
  const data = {
    planId,
    fioSigner,
    fioSignerCN,
    organizationName,
  };

  return apiPost<IValidatedUnsignedKnmByPlan>({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/knm-plan/knm/validate`,
    body: data,
  });
}

export async function fetchErknmRemoveFromPlan(
  knmIds: string[],
  code?: string,
  document?: IKnmDocument,
  linkedPmId?: number,
  requisites?: string,
): Promise<void> {
  return apiDelete(`${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/knm/plan/unlink`, {
    knmIds,
    code,
    knmDocumentDTO: document,
    linkedPmId,
    requisites,
  });
}

export async function fetchKnmRemoveFromPlan(data: IKnmExclusionRequest): Promise<void> {
  return apiPost({ url: `${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/knm/exclusion`, body: data });
}

/**
 * Функция отправления запроса на получение структурных единиц НПА
 */
export async function fetchGetNpaFromPlan(dictVersionId: string): Promise<string> {
  return apiGet(
    `${getServiceBaseURL(
      APIServiceEnum.BASE_SERVICE,
    )}/dictionaries/ervk-control-kind-npa?controlKindId=${dictVersionId}`,
  );
}

/**
 * Функция отправления запроса на получение характеров наказания
 */
export async function fetchGetPunishmentNature(): Promise<IKnmPunishmentNature> {
  return apiGet(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/erknm/punishment-nature`);
}

export async function fetchPlanHistoryChanges(): Promise<IPlanKnoChangeHistoryItem[]> {
  return apiGet(`${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/knm-plan/change-kno-history`);
}

export async function changeKnoForKnmsInPlan(planId: number, knoGuid: string, stpNumber: string): Promise<void> {
  const queryParams = new URLSearchParams();

  queryParams.append('stpNumber', stpNumber);
  queryParams.append('knoGuid', knoGuid);

  return apiPost({
    url: `${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/knm-plan/${planId}/change-kno?${queryParams}`,
  });
}
